import React from "react";
import { useState, useEffect } from "react";
import { useParams } from "react-router";
import axios from "axios";
import "./Productsdetails.css";
import { Link } from "react-router-dom";
import Parse from "html-react-parser";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { AddItem } from "../../Redux/Actions";
import Modall from "../Modal/Modall";

function Productsdetails() {
  const { id } = useParams();

  const [details, setsDetails] = useState(null);
  const [detailsInfo, setsDetailsInfo] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const result = await axios({
        method: "GET",
        url: "https://asos2.p.rapidapi.com/products/v3/detail",
        params: {
          id: `${id}`,
          lang: "en-US",
          store: "US",
          sizeSchema: "US",
          currency: "USD",
        },
        headers: {
          "x-rapidapi-key":
            "c2148b3dfamshd0306d645183132p1c3dbdjsnb84cbd6468dd",
          "x-rapidapi-host": "asos2.p.rapidapi.com",
        },
      });

      setsDetails(result.data);
      setsDetailsInfo(result.data);
      setLoading(false);
    })();
  }, []);

  useEffect(() => {
    console.log(details);
  }, [details]);

  const addToCart = useSelector((state) => state.addCart);
  console.log(addToCart);

  const dispatch = useDispatch();

  const handleAddToCart = () => {
    const list = addToCart.filter((item) => item.id === details.id);
    if (list.length > 0) {
      return null;
    } else {
      return dispatch(AddItem(details));
    }
  };

  
  return (
    <>
      {loading ? (
        <div className="loading text-center">
          <div className="spinner-grow text-dark" role="status"></div>
          <div className="spinner-grow text-warning" role="status"></div>
          <div className="spinner-grow text-dark" role="status"></div>
        </div>
      ) : (
        <div className="container products-details">
          <div className="row">
            <div className="col-lg-4 ">
              <div className="product-images">
                {details != null ? (
                  <img src={"https://" + details.media.images[0].url} alt="" />
                ) : (
                  <img src="" alt="" />
                )}
                {details != null ? (
                  <img src={"https://" + details.media.images[1].url} alt="" />
                ) : (
                  <img src="" alt="" />
                )}
                {details != null ? (
                  <img src={"https://" + details.media.images[2].url} alt="" />
                ) : (
                  <img src="" alt="" />
                )}
                {details != null ? (
                  <img src={"https://" + details.media.images[3].url} alt="" />
                ) : (
                  <img src="" alt="" />
                )}
              </div>
              <div
                id="slide"
                className="carousel slide"
                data-bs-ride="carousel"
              >
                <div className="carousel-indicators">
                  <button
                    type="button"
                    data-bs-target="#slide"
                    data-bs-slide-to="0"
                    className="active"
                    aria-current="true"
                    aria-label="Slide 1"
                  ></button>
                  <button
                    type="button"
                    data-bs-target="#slide"
                    data-bs-slide-to="1"
                    aria-label="Slide 2"
                  ></button>
                  <button
                    type="button"
                    data-bs-target="#slide"
                    data-bs-slide-to="2"
                    aria-label="Slide 3"
                  ></button>
                  <button
                    type="button"
                    data-bs-target="#slide"
                    data-bs-slide-to="3"
                    aria-label="Slide 1"
                  ></button>
                </div>
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    {details != null ? (
                      <img
                        src={"https://" + details.media.images[0].url}
                        alt=""
                      />
                    ) : (
                      <img src="" alt="" />
                    )}
                  </div>
                  <div className="carousel-item">
                    {details != null ? (
                      <img
                        src={"https://" + details.media.images[1].url}
                        alt=""
                      />
                    ) : (
                      <img src="" alt="" />
                    )}
                  </div>
                  <div className="carousel-item">
                    {details != null ? (
                      <img
                        src={"https://" + details.media.images[2].url}
                        alt=""
                      />
                    ) : (
                      <img src="" alt="" />
                    )}
                  </div>
                  <div className="carousel-item">
                    {details != null ? (
                      <img
                        src={"https://" + details.media.images[3].url}
                        alt=""
                      />
                    ) : (
                      <img src="" alt="" />
                    )}
                  </div>
                </div>
                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#slide"
                  data-bs-slide="prev"
                >
                  <span
                    className="carousel-control-prev-icon bg-dark "
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#slide"
                  data-bs-slide="next"
                >
                  <span
                    className="carousel-control-next-icon bg-dark"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
            </div>
            <div className="col-lg-5  offset-lg-2">
              {details != null ? <h4>{details.brand.name}</h4> : <h4></h4>}
              <h2>{detailsInfo.name}</h2>
              {details != null ? (
                <div className="description">
                  {Parse(`${details.info.aboutMe}`)}
                </div>
              ) : (
                <p></p>
              )}
              <div className="rating">
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star-half-alt"></i>
                <i className="far fa-star"></i>
              </div>

              <div className="select-size">
                <span> Size : </span>
                {details != null ? (
                  <select>
                    <option value="1">Select Size</option>
                    {details.variants.length > 0 ? (
                      <option value="2">
                        {details.variants[0].displaySizeText}
                      </option>
                    ) : null}
                    {details.variants.length > 1 ? (
                      <option value="3">
                        {details.variants[1].displaySizeText}
                      </option>
                    ) : null}
                    {details.variants.length > 2 ? (
                      <option value="4">
                        {details.variants[2].displaySizeText}
                      </option>
                    ) : null}
                    {details.variants.length > 3 ? (
                      <option value="5">
                        {details.variants[3].displaySizeText}
                      </option>
                    ) : null}
                    {details.variants.length > 4 ? (
                      <option value="">
                        {details.variants[4].displaySizeText}
                      </option>
                    ) : null}
                  </select>
                ) : (
                  <h4></h4>
                )}
              </div>
              <div>
                {details != null ? (
                  <h6>
                    Price : <span>{details.price.current.text}</span>
                    <del>{details.price.previous.text}</del>
                  </h6>
                ) : (
                  <h6></h6>
                )}
              </div>
              <Modall handleAddToCart={handleAddToCart} />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Productsdetails;
